import { renderToPlainText, truncateDescription } from "common";
import { Input } from "common/src/styles";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useNetwork, useSwitchNetwork } from "wagmi";
import { ReactComponent as Search } from "../../assets/search-grey.svg";
import { APPLICATION_QUESTIONS } from "../../constants";
import { useRoundById } from "../../context/RoundContext";
import { getApplicationAnswers, getProjectURIComponents } from "../../utils";
import ConfirmationModal from "../common/ConfirmationModal";
import { ProjectBanner } from "../common/ProjectBanner";
import RoundEndedBanner from "../common/RoundEndedBanner";
import { Spinner } from "../common/Spinner";
import DefaultLogoImage from "../../assets/default_logo.png";
import { BasicCard, CardContent, CardDescription, CardFooter, CardHeader, CardTitle, CardsContainer } from "../common/styles";
import NoRounds from "./NoRounds";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const CHAIN_ID = process.env.REACT_APP_IUC_ROUND_CHAIN;
const ROUND_ID = process.env.REACT_APP_IUC_ROUND_ID;
const ProjectList = props => {
  const {
    projects,
    roundRoutePath
  } = props;
  return /*#__PURE__*/_jsx(CardsContainer, {
    children: projects.map((project, index) => {
      return /*#__PURE__*/_jsx(ProjectCard, {
        project: project,
        roundRoutePath: roundRoutePath,
        isBeforeRoundEndDate: props.isBeforeRoundEndDate,
        roundId: props.roundId
      }, index);
    })
  });
};
export function ProjectCard(props) {
  var _project$projectMetad, _project$projectMetad2, _project$projectMetad3;
  const {
    project,
    roundRoutePath
  } = props;
  const isOfficial = project.status === "APPROVED";
  const badgeLabel = isOfficial ? "Official" : "Non Official";
  const badgeColor = isOfficial ? "bg-green-100 text-green-900" : "bg-orange-100 text-orange-900";
  const applicationAnswers = getApplicationAnswers(project.grantApplicationFormAnswers);
  const logoHash = project === null || project === void 0 ? void 0 : (_project$projectMetad = project.projectMetadata) === null || _project$projectMetad === void 0 ? void 0 : _project$projectMetad.logoImg;
  const applicationLogoImage = logoHash ? `https://${process.env.REACT_APP_PINATA_GATEWAY}/ipfs/${logoHash}` : DefaultLogoImage;
  const {
    id,
    registryAddress
  } = getProjectURIComponents((project === null || project === void 0 ? void 0 : (_project$projectMetad2 = project.projectMetadata) === null || _project$projectMetad2 === void 0 ? void 0 : _project$projectMetad2.id) || "");
  return /*#__PURE__*/_jsxs(BasicCard, {
    className: "relative md:w-[296px]",
    "data-testid": "project-card",
    children: [/*#__PURE__*/_jsxs(Link, {
      to: `${roundRoutePath}/${project.grantApplicationId}`,
      "data-testid": "project-detail-link",
      children: [/*#__PURE__*/_jsx(CardHeader, {
        children: /*#__PURE__*/_jsx(ProjectBanner, {
          bannerHash: applicationAnswers.get(APPLICATION_QUESTIONS.BANNER),
          classNameOverride: "bg-black h-[120px] w-full object-cover rounded-t",
          resizeHeight: 120
        })
      }), /*#__PURE__*/_jsxs(CardContent, {
        className: "px-2 [&>a]:inline-flex",
        children: [/*#__PURE__*/_jsx(CardTitle, {
          "data-testid": "project-title",
          children: applicationAnswers.get(APPLICATION_QUESTIONS.NAME)
        }), /*#__PURE__*/_jsx(Link, {
          to: `${roundRoutePath}/${project.grantApplicationId}/registry/${registryAddress}/project/${id}`,
          children: /*#__PURE__*/_jsxs("div", {
            className: "flex items-center mt-2",
            "data-testid": "project-owner",
            children: [/*#__PURE__*/_jsx("img", {
              className: "h-8 w-8 rounded-full mr-2 ring-4 ring-white bg-white",
              src: applicationLogoImage,
              alt: "Project Logo"
            }), /*#__PURE__*/_jsxs("p", {
              children: ["By ", project === null || project === void 0 ? void 0 : (_project$projectMetad3 = project.projectMetadata) === null || _project$projectMetad3 === void 0 ? void 0 : _project$projectMetad3.title]
            })]
          })
        }), /*#__PURE__*/_jsx(CardDescription, {
          "data-testid": "project-description",
          className: "h-[150px] overflow-hidden mb-1",
          children: truncateDescription(renderToPlainText(applicationAnswers.get(APPLICATION_QUESTIONS.DESCRIPTION)), 180)
        })]
      })]
    }), /*#__PURE__*/_jsx(CardFooter, {
      className: "bg-white border-t h-16",
      children: /*#__PURE__*/_jsx(CardContent, {
        className: "flex justify-between items-center text-xs pb-0 h-full",
        children: /*#__PURE__*/_jsx("div", {
          className: `rounded-full py-1 px-2 text-xs ${badgeColor}`,
          children: /*#__PURE__*/_jsx("span", {
            children: badgeLabel
          })
        })
      })
    })]
  });
}
var STATUS_FILTER = /*#__PURE__*/function (STATUS_FILTER) {
  STATUS_FILTER["ALL"] = "ALL";
  STATUS_FILTER["PENDING"] = "PENDING";
  STATUS_FILTER["APPROVED"] = "APPROVED";
  return STATUS_FILTER;
}(STATUS_FILTER || {});
const getStatusLabel = status => {
  switch (status) {
    case STATUS_FILTER.ALL:
      return "All";
    case STATUS_FILTER.APPROVED:
      return "Official";
    case STATUS_FILTER.PENDING:
      return "Non Official";
    default:
      break;
  }
};
function AfterRoundStart(props) {
  const {
    round,
    chainId,
    roundId
  } = props;
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(STATUS_FILTER.APPROVED);
  const [filteredProjects, setFilteredProjects] = useState(round.approvedProjects || []);
  const [showChangeNetworkModal, setShowChangeNetworkModal] = useState(false);
  const {
    switchNetwork
  } = useSwitchNetwork();
  const {
    chain
  } = useNetwork();
  useEffect(() => {
    if (chain && chainId && Number(chainId) !== (chain === null || chain === void 0 ? void 0 : chain.id)) {
      setShowChangeNetworkModal(true);
    } else {
      setShowChangeNetworkModal(false);
    }
  }, [chainId, chain]);
  const onSwitchNetwork = () => {
    switchNetwork === null || switchNetwork === void 0 ? void 0 : switchNetwork(Number(chainId));
  };
  function ConfirmationModalBody() {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("p", {
        className: "text-sm text-grey-400",
        children: "To view and donate to projects on this round, you need to switch the network on your wallet."
      })
    });
  }
  const renderNetworkChangeModal = () => {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line
      _jsx(ConfirmationModal, {
        isOpen: showChangeNetworkModal,
        setIsOpen: setShowChangeNetworkModal,
        confirmButtonAction: onSwitchNetwork,
        title: "Switch Network to Continue",
        body: /*#__PURE__*/_jsx(ConfirmationModalBody, {}),
        modalStyle: "wide"
      })
    );
  };
  const onSearchQueryChange = e => {
    const query = e.target.value;
    setSearchQuery(query);
  };
  const onStatusChange = e => {
    const selectedOption = e.target.value;
    setSelectedStatus(selectedOption);
  };
  useEffect(() => {
    let filteredData = round.approvedProjects || [];
    if (searchQuery) {
      var _filteredData, _filteredData2;
      const exactMatches = ((_filteredData = filteredData) === null || _filteredData === void 0 ? void 0 : _filteredData.filter(project => {
        const applicationName = getApplicationAnswers(project.grantApplicationFormAnswers).get(APPLICATION_QUESTIONS.NAME) || "";
        return applicationName.toLocaleLowerCase() === searchQuery.toLocaleLowerCase();
      })) || [];
      const nonExactMatches = ((_filteredData2 = filteredData) === null || _filteredData2 === void 0 ? void 0 : _filteredData2.filter(project => {
        const applicationName = getApplicationAnswers(project.grantApplicationFormAnswers).get(APPLICATION_QUESTIONS.NAME) || "";
        return applicationName.toLocaleLowerCase().includes(searchQuery.toLocaleLowerCase()) && applicationName.toLocaleLowerCase() !== searchQuery.toLocaleLowerCase();
      })) || [];
      filteredData = [...exactMatches, ...nonExactMatches];
    }
    if (selectedStatus !== STATUS_FILTER.ALL) {
      var _filteredData3;
      filteredData = ((_filteredData3 = filteredData) === null || _filteredData3 === void 0 ? void 0 : _filteredData3.filter(project => project.status === selectedStatus)) || [];
    }
    setFilteredProjects(filteredData);
  }, [round.approvedProjects, searchQuery, selectedStatus]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showChangeNetworkModal && renderNetworkChangeModal(), props.isAfterRoundEndDate && /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(RoundEndedBanner, {})
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col md:flex-row mb-2 w-full justify-between my-4",
      children: [/*#__PURE__*/_jsxs("p", {
        className: "text-2xl",
        children: [getStatusLabel(selectedStatus), " Applications (", filteredProjects ? filteredProjects.length : 0, ")"]
      }), /*#__PURE__*/_jsxs("div", {
        className: "relative items-center flex gap-2 flex-wrap mt-2 lg:mt-0",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "flex-shrink-0",
          children: [/*#__PURE__*/_jsx(Search, {
            className: "absolute h-4 w-4 mt-3 ml-3"
          }), /*#__PURE__*/_jsx(Input, {
            className: "w-full lg:w-64 h-8 rounded-full pl-10",
            type: "text",
            placeholder: "Search",
            value: searchQuery,
            onChange: onSearchQueryChange
          })]
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs("span", {
            className: "text-sm mx-auto md:ml-8",
            children: ["Filter ", /*#__PURE__*/_jsx("span", {
              className: "hidden md:inline mr-1",
              children: "by"
            })]
          }), /*#__PURE__*/_jsxs("select", {
            className: `border-0 cursor-pointer text-violet-400 text-sm ${selectedStatus === STATUS_FILTER.PENDING && "min-w-[110px]"}`,
            placeholder: "Status",
            onChange: onStatusChange,
            children: [/*#__PURE__*/_jsx("option", {
              value: "APPROVED",
              children: "Official"
            }), /*#__PURE__*/_jsx("option", {
              value: "PENDING",
              children: "Non Official"
            }), /*#__PURE__*/_jsx("option", {
              value: "ALL",
              children: "All"
            })]
          })]
        })]
      })]
    }), filteredProjects && /*#__PURE__*/_jsx(ProjectList, {
      projects: filteredProjects,
      roundRoutePath: `/round/${chainId}/${roundId}`,
      isBeforeRoundEndDate: props.isBeforeRoundEndDate,
      roundId: roundId
    })]
  });
}
const IUCRounds = () => {
  const {
    round,
    isLoading
  } = useRoundById(CHAIN_ID, ROUND_ID);
  const currentTime = new Date();
  const isAfterRoundEndDate = round && round.roundEndTime <= currentTime;
  const isBeforeRoundEndDate = round && round.roundEndTime > currentTime;
  if (isLoading) {
    return /*#__PURE__*/_jsx("div", {
      className: "[&>div]:w-auto",
      children: /*#__PURE__*/_jsx(Spinner, {
        text: "We're fetching applications."
      })
    });
  }
  if (round && CHAIN_ID && ROUND_ID) {
    return /*#__PURE__*/_jsx(AfterRoundStart, {
      round: round,
      chainId: Number(CHAIN_ID),
      roundId: ROUND_ID,
      isBeforeRoundEndDate: isBeforeRoundEndDate,
      isAfterRoundEndDate: isAfterRoundEndDate
    });
  }
  return /*#__PURE__*/_jsx("div", {
    className: "flex justify-center pt-8",
    children: /*#__PURE__*/_jsx(NoRounds, {
      type: "active"
    })
  });
};
export default IUCRounds;